import Vue from 'vue'
import axios from '@/plugins/axios'
import agentsAxios from '@/plugins/agentsAxios'
import { notifyWebSocketTokenRefresh } from '@/plugins/websocket'

import * as types from './types'
import store from '../../'

export default {
  authLogin ({ commit }, keycloakAuth) {
    commit(types.SECURITY_AUTH, keycloakAuth)

    if (!keycloakAuth || !keycloakAuth.token) return

    const headers = {
      'Authorization': 'Bearer ' + keycloakAuth.token,
      'realm': keycloakAuth.realm,
    }
    Object.assign(axios.defaults.headers.common, headers)
    Object.assign(agentsAxios.defaults.headers.common, headers)

    // authLogin is only dispatched on initial login or after a real token
    // refresh (see init.js / authRefresh.js — both gate on `refreshed`),
    // so an unconditional notify is correct here.
    notifyWebSocketTokenRefresh(keycloakAuth.token, keycloakAuth.realm)

    if (store.getters.isNotTrustyCDN) return
    try {
      Vue.prototype.$Tawk.$updateChatUser({
        name: keycloakAuth.tokenParsed.email,
        email: keycloakAuth.tokenParsed.email,
        hash: keycloakAuth.tokenParsed.email,
      })
    } catch (error) {
      console.log(error)
    }
  },
  authLogout ({ commit }) {
    commit(types.SECURITY_AUTH)
  }
}
